import { useEffect } from 'react';
import { omitFromQs } from 'common/utils/utils';

export const useHandleSharedLink = ({ trackingEventsHandler, inisghtId }) => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utm_source = urlParams.get('utm_source');
    if (inisghtId && utm_source) {
      trackingEventsHandler.onLinkVisit(utm_source);
      omitFromQs('utm_source');
    }
  }, [inisghtId]);
};
